import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MenuModule } from 'primeng/menu'
import { ChipComponent } from './chip.component'

@NgModule({
  declarations: [ChipComponent],
  imports: [CommonModule, MenuModule],
  exports: [ChipComponent],
})
export class ChipModule {}
